import styles from '../../assets/styles/Inventory/LinkModal.module.scss';
import { MimaButton, MimaText, MimaToastUtil, Modal } from '../../components';
import { BsFillShareFill } from 'react-icons/bs';
import { useHref, Link } from 'react-router-dom';
import config from '../../utils/config';
import { ImLink } from 'react-icons/im';
import { observer } from 'mobx-react';
import React from 'react';
import { MdOutlineContentCopy } from 'react-icons/md';

const LinkModal = ({ closeModal, goBack, productType }) => {
	const productLink = `${config.BASE_URL}/checkout/${productType.productCode}`;
	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			<MimaText variant="subtitleBold" align="center">
				Share Product Link
			</MimaText>
			<MimaText variant="small" align="center" mb={3} >
				Click on or Copy the link below
			</MimaText>

			
			<a href={productLink} target="_blank">
				<MimaText mb={3} color="var(--color-primary)" width={38} style={{textDecoration: "underline"}}>
					{productLink}
				</MimaText>
			</a>
			<div className={styles.ai__line}></div>
			<div
				onClick={() => {
					navigator.clipboard.writeText(productLink);
					MimaToastUtil.success({
						message: 'Copied!',
					});
				}}
				className={styles.ai__copy}>
				<MdOutlineContentCopy />
				<span> Click here to Copy </span>
			</div>
		</Modal>
	);
};
export default observer(LinkModal);
